<rw-modal [data-testid]="'billingFormModal'" 
  [modalTitle]="'Billing Information'" 
  [closeOnBackdropClick]="false" 
  modalId="billingFormModal"
  datapendoid="billing-form-modal"
  datatestid="billing-form-modal"
  [title]="'Billing Information'"
  [arialabel]="'Billing Information'"
  [dismissible]="true"
  size="lg"
  #modalRef>
  <div modal-body>

    @if (updateProcessing) {
    <div class="overlay">
    </div>
    }

    <div class="vertically-scrollable">
      @if (usePaymentForms && showForm) {
      <app-payment-form [allowAch]="canEditPaymentMethodType"
                        [organizationId]="billingFormData?.organization?.ID"
                        (paymentInit)="paymentInitHandler()"
                        (paymentSuccess)="paymentSuccessHandler($event)"
                        (paymentError)="paymentErrorHandler($event)"></app-payment-form>
      }
      @else {
      <form [formGroup]="frmGroup">
        <div class="row p-2">
          <div class="col-8">
            <span><strong>Organization: </strong> {{ orgName }}</span>
            <br />
            <span>{{ billingInfoConst }}</span>
          </div>
          @if (wlpBillingInfoMsg) {
          <div class="col-4">
            <p class="well position-abs m-t-neg9" [innerHtml]="wlpBillingInfoMsg"></p>
          </div>
          }
        </div>
        @if (canEditPaymentMethodType) {
        <div class="row p-2">
          <div class="col-12">
            <span class="text_14">Select a payment method</span>
            <mat-radio-group name="paymentMethod" formControlName="paymentMethod" data-testid="payment-selector">
              <div class="p-field-radiobutton col-6 pl-0">
                <mat-radio-button value="CC"
                                  (keypress)="checkSpaceClicked($event)"
                                  (click)="setPaymentMethodValidators()"
                                  id="CC"
                                  name="paymentMethod">Credit Card</mat-radio-button>
              </div>
              <div class="p-field-radiobutton col-6 pl-0">
                <mat-radio-button value="ACH" id="ACH" name="paymentMethod" (click)="setPaymentMethodValidators()">ACH</mat-radio-button>
              </div>
            </mat-radio-group>
          </div>
        </div>
        }
        <div class="row p-2">
          <div class="col-8">
            @if (paymentMethod.value === 'CC') {
            <app-payment-form-cc [parentForm]="frmGroup" [submitted]="submitted"></app-payment-form-cc>
            }
            @else if (paymentMethod.value === 'ACH' && !rnOrganizationPaymentOnFileVM?.DisableACH) {
            <app-payment-form-ach [parentForm]="frmGroup" [submitted]="submitted"></app-payment-form-ach>
            }

          </div>
        </div>
        <div class="row p-2 pt-4">
          <div class="col-8 d-flex">
            <mat-checkbox data-testid="sameBillingAddress"
                          id="sameBillingAddress"
                          name="sameBillingAddress"
                          (change)="onChangeSameBillingAddress($event.checked)">
              Billing Address is the same as my Business Address
            </mat-checkbox>
          </div>
        </div>
        <div class="row p-2">
          <div class="col-8">
            <app-business-address [address]="address"
                                  [parentForm]="frmGroup"
                                  [submitted]="submitted"></app-business-address>
          </div>
        </div>
      </form>
      }
    </div>
  </div>
  <div modal-footer>
    @if (billingFormData.missingBillingInfoOnLogin) {
      <span
        tt_datatestid="billingform-canceldisabled-tooltip"
        tt_datapendoid="billingform-canceldisabled-tooltip"
        tt_arialabel="Billing form cancel disabled tooltip"
        [rw-tooltip]="cancelTooltip">
        <a data-testid="cancellink" class="no-href-link" style="cursor: not-allowed">Cancel</a>
      </span>
      }
    @if (!this.billingFormData.missingBillingInfoOnLogin) {
    <app-button
      id="btnCancel"
      label="CANCEL"
      [disabled]="billingFormData.missingBillingInfoOnLogin"
      noContentPadding="true"
      buttonStyle="addUserTeritary"
      (clickActionEmitter)="close()"
    >
    </app-button>
    }
    @if (!usePaymentForms) {
    <app-button
      id="btnChangePackagesandAddOns"
      buttonStyle="primary"
      [attr.title]="isSubmitDisabled() ? 'Please fill out all fields' : ''"
      [disabled]="isSubmitDisabled()"
      [label]="submitButtonText"
      (clickActionEmitter)="onSubmit()"
      showProcessing="true"
      [processing]="submitted"
    >
    </app-button>
    }
  </div>
</rw-modal>
